import type { ReactNode } from "react";

type Tone = "ink" | "white" | "accent";

interface EyebrowBadgeProps {
	children: ReactNode;
	icon?: ReactNode;
	tone?: Tone;
	className?: string;
}

const TONE_CLASS: Record<Tone, string> = {
	ink: "border-accent/30 bg-accent/10 text-accent",
	white: "border-white/15 bg-white/5 text-white/80 backdrop-blur",
	accent: "border-accent/40 bg-accent/15 text-accent",
};

export function EyebrowBadge({ children, icon, tone = "ink", className = "" }: EyebrowBadgeProps) {
	return (
		<span
			className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] ${TONE_CLASS[tone]} ${className}`}
		>
			{icon}
			{children}
		</span>
	);
}
